import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { FeaturedTestimonials } from './components/FeaturedTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { PricingSection } from './components/PricingSection';
import { EliteComparison } from './components/EliteComparison';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1846495476046411');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1846495476046411&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-navy-900 font-sans text-white selection:bg-gold-500/30 selection:text-gold-200" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <FeaturedTestimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonuses data-id="element-7" />
      <PricingSection data-id="element-8" />
      <EliteComparison data-id="element-9" />
      <ExtendedTestimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostComparison data-id="element-13" />

      {/* Final CTA Section - Reusing PricingSection */}
      <div className="pt-4 pb-10 md:pt-10 md:pb-20 bg-navy-900 border-t border-gold-500/10" data-id="element-14">
        <div className="text-center mb-2" data-id="element-15">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-16">
            No dejes pasar esta oportunidad
          </h2>
        </div>
        <PricingSection data-id="element-17" />
      </div>

      <Footer data-id="element-18" />
    </div>;
}